import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.analysis.widget.search');
import { OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-analysis-widget-search',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.analysis.widget.search/view.scss */
/* src/app/portal.analysis.widget.search/view.scss: no such file or directory */`],
})
export class PortalAnalysisWidgetSearchComponent implements OnInit {
    @Input() data: Data;
    @Output() yearsChange = new EventEmitter<number[]>();

    public periodStart: number;
    public periodEnd: number;

    constructor(@Inject( Service) private service: Service) { }

    years: number[] = [];

    public async ngOnInit() {
        await this.service.init();
        this.periodStart = this.data.period.start;
        this.periodEnd = this.data.period.end;
        this.updateYears();
        await this.service.render();
    }

    async onSearchPeriod() {
        const startYear = this.data.period.start;
        const endYear = this.data.period.end;
        if (this.periodStart > this.periodEnd) {
            alert("시작년도는 종료년도보다 클 수 없습니다.");
            return;
        }
        if (this.periodStart < startYear || this.periodEnd > endYear) {
            alert(`검색 가능한 범위는 ${startYear}년 ~ ${endYear}년 입니다.`);
            return;
        }
        this.updateYears();
        this.service.render();
    }

    private updateYears() {
        if (this.periodStart && this.periodEnd && this.periodStart <= this.periodEnd) {
            this.years = Array.from(
                { length: this.periodEnd - this.periodStart + 1 },
                (_, i) => this.periodStart + i
            );
        } else {
            this.years = [];
        }
        this.yearsChange.emit(this.years);
    }
}

export default PortalAnalysisWidgetSearchComponent;